// Customer sections that other modules' pages embed (#253): the calendar of
// customer events on /account/customer-events. Registered from `./index` at
// bootstrap; the page renders it by id and does not import Customer.
// Contract: `src/lib/slots.tsx`. Registrations only.
import { registerSlot } from '@/lib/slots'

registerSlot({
    id: 'customer.calendar-events',
    load: () => import('./components/CalendarEvents'),
})
